<template>
  <div class="preview" v-if="show">
    <el-button
      class="closeBtn"
      icon="el-icon-circle-close"
      @click="closePre"
    ></el-button>
    <div
      class="flex"
      style="height: 100%; width: 100%; justify-content: space-around"
    >
      <div class="arrowBox flex" v-if="list.length > 0">
        <el-button
          circle
          class="arrowBtn"
          icon="el-icon-arrow-left"
          @click="prev"
        ></el-button>
      </div>
      <template v-if="!isVideo">
        <div class="img-box" v-if="list.length > 0">
          <img :src="imgUrl" />
        </div>
        <div class="info-box flex" v-else>
          {{ info }}
        </div>
      </template>
      <template v-else>
        <div class="player-box">
          <video-player
            class="video-player vjs-custom-skin video-box"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </div>
      </template>
      <div class="title-box" v-if="name">{{ name }}</div>
      <div class="arrowBox flex" v-if="list.length > 0">
        <el-button
          circle
          class="arrowBtn"
          icon="el-icon-arrow-right"
          @click="next"
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  components: {
    videoPlayer,
  },
  //图片预览（加边框背景）
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initialIndex: {
      // 当前显示第几个图片
      type: Number,
      default: -1,
    },
    list: {
      // 列表数据[imgurl,imgurl]
      type: Array,
      default: () => {
        return [];
      },
    },
    names: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //当无图片时传入提示信息
    info: {
      type: String,
      default: "",
    },
    //传入是否是视频
    isVideo: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: "",
    },
  },
  watch: {
    initialIndex() {
      this.resetImg();
    },
    show(v) {
      if (v) {
        if (!this.isVideo) {
          this.resetImg();
        } else {
          if (this.videoUrl) {
            this.$nextTick(() => {
              this.playerOptions.sources[0].src = this.videoUrl;
            });
          }
        }
      }
    },
  },
  data() {
    return {
      imgIndex: this.initialIndex,
      imgUrl: null,
      name: "",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: window.__config.VUE_APP_IMG_URL + "/upload/mmlz4.mp4", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  methods: {
    closePre() {
      this.$emit("update:show", false);
    },
    resetImg() {
      this.imgIndex = this.initialIndex;
      this.imgUrl = this.list[this.initialIndex];
      if (this.names.length > 0) {
        if (this.names[this.initialIndex]) {
          this.name = this.names[this.initialIndex];
        } else {
          this.name = "";
        }
      }
    },
    prev() {
      if (this.imgIndex === 0) {
        this.imgIndex = this.list.length - 1;
      } else {
        this.imgIndex = this.imgIndex - 1;
      }
      this.imgUrl = this.list[this.imgIndex];
      if (this.names.length > 0) {
        if (this.names[this.imgIndex]) {
          this.name = this.names[this.imgIndex];
        } else {
          this.name = "";
        }
      }
    },
    next() {
      if (this.imgIndex >= this.list.length - 1) {
        this.imgIndex = -1;
      }
      this.imgIndex = this.imgIndex + 1;
      this.imgUrl = this.list[this.imgIndex];
      if (this.names.length > 0) {
        if (this.names[this.imgIndex]) {
          this.name = this.names[this.imgIndex];
        } else {
          this.name = "";
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.resetImg();
    }, 100);
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
    });
  },
};
</script>

<style lang="stylus" scoped>
.preview
  position fixed
  z-index 10
  top 0
  background rgba(51, 51, 51, 0.5)
  bottom 0
  right 0
  left 0
  .img-box
    height 90%
    padding 30px
    box-sizing border-box
    border 1px solid #038397
    border-radius .02604rem
    background #011d2e
    box-shadow inset 0 0 10px #00b1cf
    img
      height 100%
  .info-box
    width 40%
    height 80%
    padding 30px
    box-sizing border-box
    border 1px solid #038397
    border-radius .02604rem
    background #011d2e
    justify-content center
    color #fff
    font-size .08rem
    box-shadow inset 0 0 10px #00b1cf
  .player-box
    width 50%
    height 40%
    // padding 30px
    box-sizing border-box
    border 1px solid #038397
    border-radius .02604rem
    background #011d2e
    justify-content center
    color #fff
    font-size .08rem
    box-shadow inset 0 0 10px #00b1cf
    .video-box
        width 100%
        height 100%
  .closeBtn
    position absolute
    right 90px
    background transparent
    border 0
    color #fff
    font-size 30px
    z-index 999
.arrowBox
  width 5%
  height 100%
  justify-content center
  z-index 10
  .arrowBtn
    background #333
    color #fff
    border 0
    font-size 30px
.title-box
    position fixed
    bottom 5vh
    color white
    font-size 15px
    line-height 1.4
</style>
